export default "__VITE_ASSET__7b004eda__"